export default __webpack_public_path__ + "static/media/c605a0b8f803fb45659ed9930669007f.png";